import React from 'react';
import { Image, ImageOverlay, StudyPlanButton, SvgIcon } from 'seduo-ui';
const Example = () => (<div className="card card-course h-100 shadow-sm" style={{
        maxWidth: '258px',
    }}>
        <ImageOverlay className="card-course__image-wrapper" topRight={<StudyPlanButton onAddToStudyPlan={() => { }} onRemoveFromStudyPlan={() => { }} title="Add to study plan"/>}>
            <a href="#" title="Bla bla">
                <Image src="https://dummyimage.com/520x350/9fa4a8/fff.png" alt="Bla bla" className="card-course__image"/>
            </a>
        </ImageOverlay>
        <div className="card-body card-course__body">
            <a className="card-course__title font-weight-medium" href="#">
                Another only one line text
            </a>
            <div className="card-course__subtitle card-course__subtitle--standalone">
                <span>
                    <a className="link card-course__link" href="#">
                        Name Surname
                    </a>
                </span>
            </div>
            <div className="card-course__subtitle card-course__subtitle--bottom">
                <div className="card-course__text">
                    <SvgIcon kind="Star" className="card-course__icon card-course__icon--rating"/>
                    &nbsp;98%
                </div>
                <div className="card-course__text">
                    <span className="mr-6">123h 45m</span>
                    <span>666 lekcí</span>
                </div>
            </div>
        </div>
        <div className="card-course__footer">
            <div className="card-course__footer-wrapper">
                <div className="card-course__text">
                    <img width="62" height="24" src="https://dummyimage.com/62x24/9fa4a8/fff.png" alt="Gift image cap" className="mr-5"/>
                </div>
                <span className="card-course__text text-truncate-line text-title">
                    Populární v Generali česká pojišťovna
                </span>
            </div>
        </div>
    </div>);
export default Example;
